<template>
  <div class="hzc-price-index">
    <div class="back">当前位置：<span @click="back('/petroleum')">石油</span> > <span
        @click="back('/petroleum/twoPage/difference')">成品油裂解价差</span> > 正文
    </div>
    <DetailTitle :title="$route.query.id+($route.query.flag === 'issue_petroleum_disintegrate_usa' ? '美国成品油裂解价差' : $route.query.flag === 'issue_petroleum_disintegrate_europe' ? '欧洲成品油裂解价差':'亚洲成品油裂解价差')"></DetailTitle>
    <el-table
        :data="tableData"
        :header-cell-style="{background:'#f2f2f2',color:'#222'}"
        border
        :max-height="400"
        style="width: 100%;margin-top: 20px;">
      <el-table-column
          align="center"
          prop="druidParamName"
          width="300"
          label="指标名称">
      </el-table-column>
      <el-table-column align="center" v-for="(item,index) in tabHead" :key="index">
        <template slot="header">
          <span>{{ item }}</span>
        </template>
        <template slot-scope="scope">
          <span>{{ scope.row[`price${index + 1}`] }}</span>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="floatPrice"
          label="涨跌幅">
        <template slot-scope="scope">
          <FloatPrice :floatPrice="scope.row['floatPrice']"/>
        </template>
      </el-table-column>
      <el-table-column
          align="center"
          prop="unitName"
          label="单位">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import DetailTitle from '@/components/common/detatilTitle'
import {differenceDetail} from '@/api/petroleum'

export default {
  name: "priceIndex",
  components: {
    DetailTitle
  },
  data() {
    return {
      flag: 'issue_petroleum_disintegrate_usa',
      tableData: [],
      tabHead: [],
    }
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      differenceDetail({dictDataType: this.flag, endTime: this.$route.query.id}).then(res => {
        this.tableData = res.data.data;
        this.tabHead = res.data['titleList'];
      })
    },
    back(url) {
      this.$router.push({path:url, query:{flag:this.flag}});
    },
  },
  mounted() {
    /**
     * 加载地图
     */
    if (this.$route.query.flag) {
      this.flag = this.$route.query.flag;
    }
    this.getDetail();
  }
}
</script>

<style scoped lang="less">
.hzc-price-index {
  width: 1200px;
  margin: 0 auto;

  .tabs {
    margin: 15px 0;

    div {
      display: inline-block;
      margin-right: 16px;
      padding: 0 10px;
      height: 36px;
      background: #F2F2F2;
      border-radius: 4px;
      border: 1px solid #CCCCCC;
      text-align: center;
      line-height: 36px;
      cursor: pointer;
    }

    div:hover {
      background-color: #D3131A;
      color: #fff;
    }
  }

  .slot-span {
    display: inline-block;
    text-align: center;
    line-height: 25px;
    width: 74px;
    height: 25px;
    background: #F2F2F2;
    border-radius: 4px;
    border: 1px solid #CCCCCC;
    cursor: pointer;
  }

  .slot-span:hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .slot-hover {
    background-color: #D3131A;
    border: 1px solid #D3131A;
    color: #fff;
  }

  .echarts {
    margin-top: 24px;
    width:1140px;
    height: 351px;
    background: #FFFFFF;
    box-shadow: 0px 2px 10px 0px rgba(183, 183, 183, 0.5);
    padding: 30px;
  }
}

.hover {
  background-color: #D3131A !important;
  border: 1px solid #D3131A !important;
  color: #fff;
}

.back{
  span {
    cursor: pointer;
  }
}
.red {
  color: #EA6535;
}

.green {
  color: #079F93;
}

.gray {
  color: #999999;
}
</style>
